module.exports = __webpack_public_path__ + "img/close.a627cbb9.svg";